import { useSelector } from 'react-redux';
import   './TodayCurve.css'
import { BarChart, Bar, XAxis, ResponsiveContainer } from "recharts";

function TodayCurve({todayItems}) {
  const data = [
    { hour: "10", value: 30 },
    { hour: "10", value: 50 },
    { hour: "11", value: 25 },
    { hour: "12", value: 45 },
    { hour: "13", value: 40 },
    { hour: "14", value: 28 },
  ];
  const { currentLocal } = useSelector((state) => state.currentLocal);
  
  return (
    <div className="today_curve_container card shadow-sm p-3 rounded" style={{ width: "100%" }}>
      <div className="card-body text-center">
        <h5 className="title mb-4">{currentLocal.home.TodaysAttendance}</h5>

        <div style={{ width: "100%", height: "120px" }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data}>
              <XAxis dataKey="hour" axisLine={false} tickLine={false}tick={{ fill: "#767676", fontSize: 12, fontWeight: "700" }} />
              <Bar dataKey="value" fill="#FF6B6B" radius={[5, 5, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="mt-1">
          <div className="d-flex justify-content-between border-bottom pb-3">
            <span className="item_title">{currentLocal.home.Absent}</span>
            <span className=" item_Value">{todayItems&&todayItems.absent==0?"0":todayItems&&todayItems.absent}</span>
          </div>
   
          <div className="d-flex justify-content-between border-bottom py-3">
            <span className="item_title text-success ">{currentLocal.home.Attended}</span>
            <span className="item_Value text-success">{todayItems&&todayItems.attended==0?"0":todayItems&&todayItems.attended}</span>
          </div>
        
          <div className="d-flex justify-content-between pt-2">
            <span className="item_title text-black">{currentLocal.home.TotalStudentsText}</span>
            <span className="item_Value text-black">{todayItems&&todayItems.total_students==0?"0":todayItems&&todayItems.total_students}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TodayCurve
